import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { reduxForm, Field, reset, change } from "redux-form";
import { NotificationManager } from "react-notifications";

import { FormField } from "../../../../sharedComponents/formField";
import { getSources } from "../../../../store/actions";
import { required } from "../../../../constants/formValidators";

import SourceListing from "../../sources/SourceListing";

const SelectSourceForm = ({
	getSources,
	sourceList,
	handleSubmit,
	onUpdate,
	resetForm,
	submitting,
	togglePanel,
	recipeSourceList,
	change
}) => {
	useEffect(() => {
		getSources();
	}, [getSources]);

	const [disable, setDisable] = useState(false);

	const validateForm = (values) => {
		setDisable(true);
		const isExists = recipeSourceList
			? recipeSourceList.filter((item) => Number(item.source) === Number(values.source)).length > 0
			: false;
		if (isExists) {
			NotificationManager.error("Please select another source!", "", 5000);
		} else {
			const source_data = sourceList.filter((item) => Number(item.id) === Number(values.source))[0];
			onUpdate({ ...values, source_data });
			resetForm("SelectSourceForm");
		}
	};

	const [animPanel, setAnimPanel] = useState(1);

	const onBack = (event) => {
		const selectedItem = sourceList.filter(item => event.data.id === item.id);
		selectedItem && selectedItem.length && change('SelectCategoryForm', 'category', selectedItem[0].id);
		setAnimPanel(event.panel);
	}

	return sourceList && sourceList.length ? (
		<div className="anim-panel">
			<div className={`list-panel panel ${animPanel === 1 ? "active" : ""}`}>
				<form className="flex-fill d-flex flex-column w-100 select-source-wrap select-category-wrap h-100" onSubmit={handleSubmit(validateForm)}>
					<div className="flex-fill">
						<h5 className="text-primary-dark mb-2">Add a source</h5>
						<div className="d-flex">
							<div className="mr-3 field-seq">
								<Field name="seq" formGroupClass="m-0" type="number" min="1" component={FormField} label="Seq" />
							</div>
							<div className="flex-fill field-source">
								<Field
									name="source"
									formGroupClass="m-0"
									type="select"
									options={sourceList}
									component={FormField}
									validate={[required]}
									label="Source"
									onChange={() => setDisable(false)}
								/>
							</div>
						</div>
					</div>
					<div className="d-flex align-items-end">
						<div className="flex-fill">
							<h5 className="text-primary-dark mt-3">Cannot find a source?</h5>
							<button type="button" className="btn btn-primary-dark btn-ghost" onClick={() => setAnimPanel(2)}>
								<i className="icon icon-add-edit" /> Edit or Add
					</button>
						</div>
						<div className="text-right">
							<button className="btn btn-default" type="button" onClick={() => togglePanel(false)}>
								Cancel
					</button>
							<button className="btn btn-primary-dark" type="submit" disabled={submitting || disable}>
								Add Now
					</button>
						</div>
					</div>
				</form>
			</div>
			<div className={`add-edit-panel panel ${animPanel === 2 ? "active" : ""}`}>
				<SourceListing onBack={onBack} />
			</div>
		</div>
	) : null;
};

const mapStateToProps = (state) => {
	return {
		sourceList: get(state, "AddRecipe.sourceList", [])
	};
};

const mapDispatchToProps = {
	getSources,
	resetForm: reset,
	change
};

export default reduxForm({
	form: "SelectSourceForm",
	enableReinitialize: true
})(connect(
	mapStateToProps,
	mapDispatchToProps
)(SelectSourceForm)
);
